import { NgClass } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import {
    Component,
    HostListener,
    ChangeDetectionStrategy
} from '@angular/core';
import { ToggleService } from '../sidebar/toggle.service';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { AuthService } from '../../authentication/service/auth.service';
import { LocaleService } from '../../services/locale.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-header',
    imports: [
        NgClass,
        MatMenuModule,
        MatButtonModule,
        RouterLink,
        TranslatePipe
    ],
    templateUrl: './header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './header.component.scss'
})
export class HeaderComponent {
    username: string | null = '';

    isSidebarToggled = false;

    isToggled = false;

    constructor(
        private toggleService: ToggleService,
        public themeService: CustomizerSettingsService,
        private authService: AuthService,
        private localeService: LocaleService
    ) {
        this.toggleService.isSidebarToggled$.subscribe(isSidebarToggled => {
            this.isSidebarToggled = isSidebarToggled;
        });
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
        this.username = localStorage.getItem('username');
    }

    toggle() {
        this.toggleService.toggle();
    }

    isSticky: boolean = false;
    @HostListener('window:scroll')
    checkScroll() {
        const scrollPosition =
            window.scrollY ||
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            0;
        if (scrollPosition >= 50) {
            this.isSticky = true;
        } else {
            this.isSticky = false;
        }
    }

    changeLanguage(lang: 'da' | 'en') {
        this.localeService.setLocale(lang);
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    onLogout() {
        this.authService.logOut();
    }
}
